/**
 * @link https://datatracker.ietf.org/doc/html/rfc5424#section-6.2.1
 */
export enum SyslogFacility {
  Kernel = 0,
  User = 1,
  System = 3,
  Audit = 13,
  Alert = 14,
  Local0 = 16,
  Local1 = 17,
  Local2 = 18,
  Local3 = 19,
  Local4 = 20,
  Local5 = 21,
  Local6 = 22,
  Local7 = 23,
}
